import { EN_GB } from "@constants/locale";

interface Options {
    fraction: number,
    spaceBetween: boolean,
    style?: Intl.NumberFormatOptionsStyle
}

const currencyOptions: Options = {
    fraction: 0,
    spaceBetween: true,
    style: 'currency'
}

export function currencySymbol(locale: string, currency: string): string {
    if (currency === '') {
        return '';
    }

    return new Intl.NumberFormat(locale, { style: 'currency', currency })
        .formatToParts(1)
        .find(part => part.type === 'currency')
        ?.value ?? '';
}

function addSpaceBetween(formattedValue: string, currency: string, locale: string): string {
    const symbol = currencySymbol(locale, currency);

    if (formattedValue.includes(' ') && formattedValue.includes(symbol)) {
        return formattedValue;
    }

    const currencySeparator = ' ';
    let replaced = formattedValue.replace(symbol, symbol + currencySeparator);
    if (formattedValue.indexOf(symbol) !== 0) {
        replaced = formattedValue.replace(symbol, currencySeparator + symbol);
    }

    return replaced;
}

export function format(value: number, currency: string, locale: string, customOptions: Options = currencyOptions): string|number {
    if (!currency) {
        return value;
    }

    const options = {
        ...currencyOptions,
        ...customOptions
    }

    let formattedValue = new Intl.NumberFormat(locale, {
        style: options.style,
        currency,
        minimumFractionDigits: options.fraction
    }).format(value);

    if (options.spaceBetween && locale !== EN_GB) {
        formattedValue = addSpaceBetween(formattedValue, currency, locale);
    }

    return formattedValue;
}
